import z from 'zod';
const invoiceCurrencyValue = z.literal('eur');
export const invoiceAmountSchema = z.strictObject({
    // Signed: Stripe proration credit invoices can have total < 0.
    amountInCents: z.number().int(),
    currency: invoiceCurrencyValue,
});
export function createInvoiceAmount(input) {
    return invoiceAmountSchema.parse({
        amountInCents: input.amountInCents,
        currency: input.currency,
    });
}
//# sourceMappingURL=invoice-amount.js.map